import _ from 'lodash';

import client from './RestClient';
import {
  DraftCreateDTO,
  DraftValidationDTO,
  DraftPublishResponse
} from 'core/draft/Draft';
import { AxiosInstance } from 'axios';

export interface DraftWebService {
  createDraft(draftCreateDTOList: DraftCreateDTO[]): Promise<void>;
  getValidationInfos(
    draftCreateDTOList: DraftCreateDTO[]
  ): Promise<DraftValidationDTO[]>;
  getDraft(channelGroupId: number, draftId: string): Promise<any>;
  updateDraft(channelGroupId: number, draftId: string, data: any): Promise<any>;
  publishDraft(
    channelGroupId: number,
    draftId: string,
    data: any
  ): Promise<DraftPublishResponse>;
  deleteDrafts(draftIds: (string | number)[]): Promise<void>;
}

export class RestfulDraftWebService implements DraftWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async createDraft(draftCreateDTOList: DraftCreateDTO[]): Promise<void> {
    await this.restClient.post('/v3/l2-object/draft', draftCreateDTOList);
  }

  async getValidationInfos(
    draftCreateDTOList: DraftCreateDTO[]
  ): Promise<DraftValidationDTO[]> {
    const request = _.map(draftCreateDTOList, (draftCreateDTO) =>
      _.omitBy(draftCreateDTO, ['channelGroupId', 'numberOfCopies'])
    );
    const response = await this.restClient.post(
      '/v3/l2-object/draft/validation-info',
      request
    );
    return _.get(response, 'data.records', []);
  }

  async getDraft(channelGroupId: number, draftId: string): Promise<any> {
    const response = await this.restClient.get(
      `/v3/l2-object/draft/${channelGroupId}/${draftId}`
    );
    return response.data;
  }

  async updateDraft(
    channelGroupId: number,
    draftId: string,
    data: any
  ): Promise<any> {
    return this.restClient.put(
      `/v3/l2-object/draft/${channelGroupId}/${draftId}`,
      data
    );
  }

  async publishDraft(
    channelGroupId: number,
    draftId: string,
    data: any
  ): Promise<DraftPublishResponse> {
    const response = await this.restClient.post(
      `/v3/l2-object/draft/${channelGroupId}/${draftId}/publish`,
      data
    );
    return response.data;
  }

  async deleteDrafts(draftIds: (string | number)[]): Promise<void> {
    return this.restClient.delete(
      `/v3/l2-object/draft?draftIds=${draftIds.join(',')}`
    );
  }
}
